import { LoadPanel } from 'devextreme-react';
import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import CardBillListV2 from './card-bill-list-v2';
import CardBillListStore from './card-bill-list-store';
import moment from 'moment';

const CardBillListContainer = () => {
  // console.log('CardBillListContainer Load');

  const { cardBillList } = CardBillListStore;
  const { cusEntAmount } = CardBillListStore;

  const [useInfo, setUseInfo] = useState({
    // FromDate: moment().add(-1, 'months').format('YYYYMMDD'),
    // ToDate: moment().add(-1, 'days').format('YYYYMMDD')
    FromDate: moment().format('YYYYMMDD'),
    ToDate: moment().format('YYYYMMDD')
  });

  useEffect(() => {
    CardBillListStore.getCardBillList();
    CardBillListStore.getCusEntAmount();
  }, []);

  const onValueChanged = useCallback((name, e) => {
    const { value, event } = e;
    let isDate = false;

    if (name === 'FromDate' || name === 'ToDate') {
      if (event) {
        isDate = true;
      } else {
        return;
      }
    }

    setUseInfo((useInfo) => ({
      ...useInfo,
      [name]: isDate ? moment(value).format('YYYYMMDD') : value,
    }));
  }, []);

  const onClickSearch = useCallback(async () => {
    const result1 = await CardBillListStore.getCardBillList(
      useInfo.FromDate,
      useInfo.ToDate,
    );
    const result2 = await CardBillListStore.getCusEntAmount();
  }, [useInfo]);

  const onClickWithdraw = useCallback(async () => {
    CardBillListStore.setVisibleWithdrawPopup(true);
  }, []);

  const onClickAccountInfo = useCallback(async () => {
    CardBillListStore.setVisibleAccountInfoPopup(true);
  }, []);

  if (!useInfo) {
    return;
  }

  if (!cusEntAmount){
    return;
  }

  return (
    <CardBillListV2
      onClickSearch={onClickSearch}
      cardBillList={cardBillList}
      useInfo={useInfo}
      onValueChanged={onValueChanged}
      cusEntAmount={cusEntAmount}
      onClickWithdraw={onClickWithdraw}
      onClickAccountInfo={onClickAccountInfo}
    />
  );
};

export default React.memo(observer(CardBillListContainer));
